export default __webpack_public_path__ + "static/media/02.20cb1808.jpg";